/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
};

const SvgComponent: FC<IProps> = ({ width = 24, height = 24 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12 21.425C10.7 21.425 9.47918 21.175 8.33751 20.675C7.19584 20.175 6.20001 19.5 5.35001 18.65C4.50001 17.8 3.82501 16.8042 3.32501 15.6625C2.82501 14.5208 2.57501 13.3 2.57501 12C2.57501 10.7 2.82501 9.47501 3.32501 8.32501C3.82501 7.17501 4.50001 6.17501 5.35001 5.32501C6.20001 4.47501 7.19584 3.80418 8.33751 3.31251C9.47918 2.82085 10.7 2.57501 12 2.57501C13.3 2.57501 14.525 2.82085 15.675 3.31251C16.825 3.80418 17.825 4.47501 18.675 5.32501C19.525 6.17501 20.1958 7.17501 20.6875 8.32501C21.1792 9.47501 21.425 10.7 21.425 12C21.425 13.3 21.1792 14.5208 20.6875 15.6625C20.1958 16.8042 19.525 17.8 18.675 18.65C17.825 19.5 16.825 20.175 15.675 20.675C14.525 21.175 13.3 21.425 12 21.425ZM12 20.325C14.3167 20.325 16.2833 19.5125 17.9 17.8875C19.5167 16.2625 20.325 14.3 20.325 12C20.325 9.68334 19.5167 7.71668 17.9 6.10001C16.2833 4.48335 14.325 3.67501 12.025 3.67501C9.70834 3.67501 7.73751 4.48335 6.11251 6.10001C4.48751 7.71668 3.67501 9.67501 3.67501 11.975C3.67501 14.2917 4.48751 16.2625 6.11251 17.8875C7.73751 19.5125 9.70001 20.325 12 20.325Z" fill="#262626" />
  </svg>
);

export default SvgComponent;
